/* @remove-on-es-build-begin */
// this file is not used if use https://github.com/ant-design/babel-plugin-import
const ENV = process.env.NODE_ENV;
if (
  ENV !== "production" &&
  ENV !== "test" &&
  typeof console !== "undefined" &&
  console.warn && // eslint-disable-line no-console
  typeof window !== "undefined"
) {
  // eslint-disable-next-line no-console
  console.warn(
    "You are using a whole package of yach.open.ui, " +
      "please use https://www.npmjs.com/package/babel-plugin-import to reduce app bundle size."
  );
}
/* @remove-on-es-build-end */

export { default as ComplexPicker } from "./components/complex-picker";
export { default as Demo } from "./components/demo";
export { default as Sscard } from "./components/sscard";
// ci
